import { fetchCachedHelper, fetchHelper } from '../../../api/api'
import { cancelSubscriptionActions } from './cancelSubscriptionSlice'
import { getErrorMessage } from '../../../util/functions'
import { fetchCourseDetails } from '../../../api/apiFunctions'
import { userActions } from '../../../redux/userSlice'

export const getFreeCourses = email => async dispatch => {
    try {
        dispatch(cancelSubscriptionActions.getFreeCoursesRequest())
        //TODO: Figure out whether to still use this
        const response = await fetchCachedHelper(
            `Customercourse/CustomerFreeCourses/${email}`,
            {
                cache: {
                    maxAge: 2 * 60 * 1000,
                },
            }
        )
        let freeCourses = response.data
        const courseDetails = await Promise.all(
            freeCourses.map(({ coursecode }) => fetchCourseDetails(coursecode))
        )

        freeCourses = freeCourses
            .map((_, idx) => courseDetails[idx])
            .filter(courseDetails => courseDetails) //Filter out courses that might have been deleted for some reason

        dispatch(
            cancelSubscriptionActions.getFreeCoursesRequestSuccess(freeCourses)
        )
    } catch (e) {
        dispatch(
            cancelSubscriptionActions.getFreeCoursesRequestError(
                getErrorMessage(e)
            )
        )
    }
}

export const cancelSubscription = email => async dispatch => {
    try {
        dispatch(cancelSubscriptionActions.cancelSubscriptionRequest())
        const response = await cancelUserSubscription(email)
        if (response.data.success) {
            dispatch(
                userActions.updateDetails({ userDetails: response.data.data })
            )
            dispatch(
                cancelSubscriptionActions.cancelSubscriptionRequestSuccess()
            )
        } else {
            dispatch(
                cancelSubscriptionActions.cancelSubscriptionRequestError(
                    'Something went wrong while cancelling your subscription'
                )
            )
        }
    } catch (e) {
        dispatch(
            cancelSubscriptionActions.cancelSubscriptionRequestError(
                getErrorMessage(e)
            )
        )
    }
}

export const cancelUserSubscription = (email, reasons) =>
    fetchHelper.delete(
        `Customersubscription/CancelSubscription/${email}?reasons=${reasons}`
    )

export const hasFreeCourses = async email => {
    const response = await fetchCachedHelper(
        `Customercourse/CustomerFreeCoursesd/${email}`,
        {
            cache: {
                maxAge: 2 * 60 * 1000,
            },
        }
    )

    return response.data?.length > 0
}
